// ./src/config/icons.ts
export const ICON_SIZE_MAP: Record<string, number> = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
};
